import { render } from "./CopySessionLinkIcon.vue?vue&type=template&id=47d32bc4"
import script from "./CopySessionLinkIcon.vue?vue&type=script&lang=js"
export * from "./CopySessionLinkIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__